module.exports = __webpack_public_path__ + "static/media/orange-logo.95010603.png";